var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFocusLevel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-1e9e2aaa": "",
    "data-v-304a6410": "",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    className: "icon medium",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 24.8366 7.16344 32 16 32L18.9995 16.2539L16 0C7.16344 0 0 7.16344 0 16Z",
    fill: "#64AB92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 12.5591 30.9138 9.37187 29.0657 6.76256L25.2499 2.94319C22.6382 1.08963 19.4464 0 16 0V32C24.8366 32 32 24.8366 32 16Z",
    fill: "#429E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92269 16C7.92269 11.5432 11.539 7.93035 16 7.93035L17.2339 5.99579L16 3.98535C9.35819 3.98535 3.97388 9.36448 3.97388 16C3.97388 22.6355 9.35819 28.0146 16 28.0146L17.4546 25.9604L16 24.0696C11.539 24.0696 7.92269 20.4567 7.92269 16Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2414 15.9999C12.2414 18.0738 13.9242 19.755 16 19.755L17.8793 16.2538L16 12.2449C13.9242 12.2449 12.2414 13.9261 12.2414 15.9999Z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0261 16C28.0261 9.36448 22.6419 3.98535 16 3.98535V7.93035C20.461 7.93035 24.0773 11.5432 24.0773 16C24.0773 20.4567 20.461 24.0696 16 24.0696V28.0146C22.6418 28.0146 28.0261 22.6355 28.0261 16Z",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7586 15.9999C19.7586 13.9261 18.0758 12.2449 16 12.2449V19.7549C18.0758 19.755 19.7586 18.0738 19.7586 15.9999Z",
    fill: "#ffffff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3859 7.39692L15.4383 15.337C15.0719 15.703 15.0718 16.2966 15.438 16.6629C15.4406 16.6654 15.4434 16.6675 15.446 16.6701L21.3761 11.1736L24.6839 7.37161C24.3161 7.03223 23.7431 7.04011 23.3859 7.39692Z",
    fill: "#224735"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7645 16.6631L24.7121 8.72308C25.0784 8.35708 25.0786 7.76346 24.7124 7.39721C24.7032 7.38808 24.6934 7.38027 24.684 7.37158L15.4461 16.6701C15.6282 16.8481 15.8647 16.9376 16.1014 16.9376C16.3414 16.9375 16.5814 16.8461 16.7645 16.6631Z",
    fill: "#224735"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6541 2.98478L27.9441 0.757532C27.8216 0.37322 27.3354 0.255095 27.05 0.540157L22.6201 4.96578C22.4187 5.16697 22.3496 5.46522 22.4419 5.73441L23.3301 8.32466C23.3632 8.42103 23.416 8.50735 23.4824 8.58103L26.7959 6.53816L28.7929 3.23578C28.7317 3.16278 28.6838 3.07816 28.6541 2.98478Z",
    fill: "#F5B95F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8099 8.7934L26.2836 9.5779C26.549 9.66209 26.8393 9.5914 27.0361 9.39465L31.4571 4.97784C31.7466 4.68865 31.6204 4.19528 31.2277 4.08034L29.1549 3.47371C29.0111 3.43165 28.8862 3.34753 28.7928 3.23584L23.4824 8.58109C23.5699 8.67822 23.6818 8.75278 23.8099 8.7934Z",
    fill: "#F5B95F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusLevel);
export default __webpack_public_path__ + "static/media/focus_level.68bd88fa2d006dec3c336b403c6b0a67.svg";
export { ForwardRef as ReactComponent };